import { Component, ElementRef, input, TemplateRef, ViewChild } from '@angular/core';
import { IconComponent } from 'src/app/shared/components/ui/icon/icon.component';
import { PopupRef, PopupService } from '@progress/kendo-angular-popup';
import { SafePipe } from 'safe-pipe';


const HIDE_POPUP_DELAY_TIME = 100; //ms
@Component({
  selector: 'bizz-popup',
  standalone: true,
  imports: [
    IconComponent,
    SafePipe
  ],
  templateUrl: './popup.component.html',
  styleUrl: './popup.component.scss'
})
export class PopupComponent {
  @ViewChild('anchor', { read: ElementRef })
  public anchorEl: ElementRef;

  @ViewChild('readmorePopupTemplateRef', { static: true })
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public readmorePopupTemplateRef: TemplateRef<any>;

  /**
   * The title of the popup
   */
  public title = input<string>();
  /**
   * Html content to show in the popover
   */
  public body = input.required<string>();


  /**
   * Icon name to show in the popover (optional)
   * @default circle-info
   */
  public iconName = input<string>('circle-info');


  private readmorePopup: PopupRef | null = null;

  private anchorHovered = false;
  private popupHovered = false;

  public constructor(private popupService: PopupService) {
  }

  public onAnchorMouseEnter(): void {
    this.anchorHovered = true;
    this.showPopup();
  }

  public onAnchorMouseLeave(): void {
    this.anchorHovered = false;
    setTimeout(() => {
      if (!this.anchorHovered && !this.popupHovered) this.hidePopup();
    }, HIDE_POPUP_DELAY_TIME);
  }

  public onPopupMouseEnter(): void {
    this.popupHovered = true;
    this.showPopup();
  }

  public onPopupMouseLeave(): void {
    this.popupHovered = false;
    setTimeout(() => {
      if (!this.anchorHovered && !this.popupHovered) this.hidePopup();
    }, HIDE_POPUP_DELAY_TIME);
  }

  public showPopup(): void {
    if (this.readmorePopup != null) return;

    this.readmorePopup = this.popupService.open({
      anchor: this.anchorEl,
      content: this.readmorePopupTemplateRef,
      popupClass:
        'w-svw h-svh sm:w-fit sm:h-auto sm:min-w-[400px] sm:-mt-[0.5rem] sm:rounded-md maxw-sm:!top-0 !z-[9999] maxw-sm:!left-0 maxw-sm:!right-0',
      animate: false,
      anchorAlign: { horizontal: 'left', vertical: 'bottom' },
      popupAlign: { horizontal: 'left', vertical: 'top' },
      collision: { horizontal: 'fit', vertical: 'fit' }
    });
  }

  public hidePopup(): void {
    if (this.readmorePopup) {
      this.readmorePopup.close();
      this.readmorePopup = null;
    }
    event?.stopPropagation();
    event?.preventDefault();
  }
}
